import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useParams, shallowEqual } from 'umi';
import {
  checkReportIdWithName,
  getDashboardType,
  getPathFromDashboard,
} from '@/pages/dashboard/utils/utils';
import { LOG_SYSTEM_TYPE, PAGE_TYPE_LOOKER } from '@/pages/dashboard/_config/constant';
import { getLookerEmbedSession } from '@/pages/dashboard/services/dashboard';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import LookerCookieless from '@home/components/LookerCookieless';
import { ILookerSessionDefaultType } from '@home/components/LookerCookieless/type';

export default () => {
  const [sessionInfo, setSessionInfo] = useState<ILookerSessionDefaultType>();
  const dashboardRef = useRef<any>(null);
  const { reportId } = useParams() as any;
  const { currentMenu, currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentMenu, currentGame } = state.dashboard;
    return {
      currentMenu,
      currentGame
    };
  }, shallowEqual);

  const [loading, setLoading] = useState(true);

  // iframe 处理
  const openIframeReport = () => {
    if (!reportId || !currentGame) {
      return;
    }
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_LOOKER || !checkReportIdWithName(reportId, currentMenu?.name_en)) {
      return;
    }

    dashboardRef.current = currentMenu;
    const { url } = currentMenu;

    if (!url) {
      return;
    }
    const { game_code: gameCode } = currentGame;
    const params = {
      url: currentMenu?.url || '',
      u_id: currentMenu?.u_id || '',
      game_code: gameCode
    };
    setLoading(true);
    getLookerEmbedSession(params).then((data) => {
      const sessionInfo = data || '';
      if (dashboardRef.current?.id !== currentMenu?.id) {
        return;
      }
      if (sessionInfo) {
        setSessionInfo(sessionInfo);
        setLoading(false);
        // 打点
        const { id = '', name_en: nameEn } = currentMenu || {};
        const logObj = {
          pageId: id,
          menuId: id,
          pageName: nameEn,
          extInfo: nameEn,
          pagePath: getPathFromDashboard(currentMenu),
          uid: gameCode,
          typeId: LOG_SYSTEM_TYPE,
        };
        buriedPoint(logObj);
      }
    }).catch(e => {
      console.log(e);
    });
  };

  useEffect(() => {
    openIframeReport();
  }, [reportId, currentMenu]);

  return (
    <>
      {sessionInfo && <LookerCookieless sessionInfo={sessionInfo} loading={loading}></LookerCookieless>}
    </>
  );
};